
// Dependencies
import Vue from 'vue';
import Vuex from 'vuex';

// Local
import api from './util/api';

// Register vuex
Vue.use (Vuex);

const store = new Vuex.Store (
{
	state:
	{
		loading: false,
		tag: null,
		message: null
	},
	mutations:
	{
		SET_LOADING (state, loading)
		{
			state.loading = loading;
		},
		SET_MESSAGE (state, message)
		{
			state.message = message;
		},
		SET_TAG (state, tag)
		{
			state.tag = tag;
		}
	},
	actions:
	{
		clearMessage (ctx)
		{
			ctx.commit ('SET_MESSAGE', null);
		},
		async getTag (ctx, tagID: string)
		{
			const tag = await api.getTag (tagID);
			ctx.commit ('SET_TAG', tag);
		},
		async registerTag (ctx, data)
		{
			const tag = await api.registerTag (data);
			ctx.commit ('SET_TAG', tag);
		},
		setMessage (ctx, { message, details, error = false, nextUrl = null })
		{
			ctx.commit ('SET_MESSAGE', { message, details, error, nextUrl });
		}
	}
});

api.loading.subscribe ({
	next: v => store.commit ('SET_LOADING', v)
});

export default store;
